module.exports = __webpack_public_path__ + "img/largeScreenTitle.2ca359c0.png";